/* eslint jsx-a11y/href-no-hash: "off" */
import React from "react";
import { connect } from "react-redux";

class LobbyModal extends React.Component {
  handleClose(e) {
    if (e) {
      e.preventDefault();
    }
    this.props.handleCloseCallback();
  }

  getDesktopStyle() {
    const { vW } = this.props;
    return {
      maxWidth: vW * 40,
      fontSize: "0.5em",
      //padding: "3em",
      left: "50%",
      top: "50%",
      transform: "translate(-50%,-50%)"
    };
  }

  getMobileStyle() {
    //const {vW} = this.props;
    return {
      fontSize: "0.7em",
      top: "2%"
    };
  }

  render() {
    const { viewportMode } = this.props;

    const modalStyle = {
      margin: "0 auto",
      position: "absolute",
      left: "5%",
      right: "5%",
      borderLeft: "0.4em solid #200535",
      borderRight: "0.4em solid #200535",
      ...(viewportMode === "landscape"
        ? this.getDesktopStyle()
        : this.getMobileStyle())
    };

    return (
      <div className="ModalOverlay">
        <div className="Modal" style={modalStyle}>
          <div className="Modal--top-bar">
            <div>
              {this.props.title}
            </div>
            <div>
              <a
                className="Modal--close"
                href="#"
                onClick={this.handleClose.bind(this)}
              >
                &times;
              </a>
            </div>
          </div>
          <div className="Modal--content-container">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    vW: state.global.vW,
    viewportMode: state.global.viewportMode
  };
})(LobbyModal);



// WEBPACK FOOTER //
// ./src/b5-home/LobbyModal.js